import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

/**
 * Базовый URL для IndorID API
 * В development используется прокси /indorweb/, в production - https://indorweb/
 */
export const INDORID_BASE_URL =
    process.env.NODE_ENV === 'development'
        ? '/indorweb/'
        : 'https://indorweb/';

const baseUrl = INDORID_BASE_URL;

const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    redirect: 'manual',
    fetchFn: async (...args) => {
        const res = await fetch(...args);
        if (res.type === "opaqueredirect" || res.status === 0) {
            return new Response(null, { status: 200, statusText: 'Login Redirect (OK)' });
        }
        return res;
    },
})

export const indorsoftRuAPI = createApi({
    reducerPath: 'indorsoftRuAPI',
    baseQuery,
    endpoints: builder => ({})
})

export const indorsoftRuAPIReducer = indorsoftRuAPI.reducer
export const resetIndorsoftRuAPI = indorsoftRuAPI.util.resetApiState